"use strict";

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ms_rest_azure_js_1 = require("ms-rest-azure-js");
exports.CloudError = ms_rest_azure_js_1.CloudErrorMapper;
exports.BaseResource = ms_rest_azure_js_1.BaseResourceMapper;
exports.AddUsersPayload = {
  required: false,
  serializedName: 'AddUsersPayload',
  type: {
    name: 'Composite',
    className: 'AddUsersPayload',
    modelProperties: {
      emailAddresses: {
        required: true,
        serializedName: 'emailAddresses',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      }
    }
  }
};
exports.ConnectivityPolicy = {
  required: false,
  serializedName: 'ConnectivityPolicy',
  type: {
    name: 'Composite',
    className: 'ConnectivityPolicy',
    modelProperties: {
      rdpEnabled: {
        required: false,
        serializedName: 'RdpEnabled',
        type: {
          name: 'String'
        }
      },
      rdpInBrowserEnabled: {
        required: false,
        serializedName: 'RdpInBrowserEnabled',
        type: {
          name: 'String'
        }
      },
      sshEnabled: {
        required: false,
        serializedName: 'SshEnabled',
        type: {
          name: 'String'
        }
      },
      sshInBrowserEnabled: {
        required: false,
        serializedName: 'SshInBrowserEnabled',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ConnectivityPolicyFragment = {
  required: false,
  serializedName: 'ConnectivityPolicyFragment',
  type: {
    name: 'Composite',
    className: 'ConnectivityPolicyFragment',
    modelProperties: {
      rdpEnabled: {
        required: false,
        serializedName: 'RdpEnabled',
        type: {
          name: 'String'
        }
      },
      rdpInBrowserEnabled: {
        required: false,
        serializedName: 'RdpInBrowserEnabled',
        type: {
          name: 'String'
        }
      },
      sshEnabled: {
        required: false,
        serializedName: 'SshEnabled',
        type: {
          name: 'String'
        }
      },
      sshInBrowserEnabled: {
        required: false,
        serializedName: 'SshInBrowserEnabled',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.CoreData = {
  required: false,
  serializedName: 'CoreData',
  type: {
    name: 'Composite',
    className: 'CoreData',
    modelProperties: {
      coreFamily: {
        required: false,
        readOnly: true,
        serializedName: 'coreFamily',
        type: {
          name: 'String'
        }
      },
      numberOfCores: {
        required: false,
        readOnly: true,
        serializedName: 'numberOfCores',
        type: {
          name: 'Number'
        }
      }
    }
  }
};
exports.LabParameters = {
  required: false,
  serializedName: 'LabParameters',
  type: {
    name: 'Composite',
    className: 'LabParameters',
    modelProperties: {
      vmSize: {
        required: true,
        serializedName: 'vmSize',
        type: {
          name: 'String'
        }
      },
      galleryImageResourceId: {
        required: false,
        serializedName: 'galleryImageResourceId',
        type: {
          name: 'String'
        }
      },
      sharedImageResourceId: {
        required: false,
        serializedName: 'sharedImageResourceId',
        type: {
          name: 'String'
        }
      },
      templateVmState: {
        required: true,
        serializedName: 'templateVmState',
        type: {
          name: 'String'
        }
      },
      linuxRdpState: {
        required: false,
        serializedName: 'linuxRdpState',
        type: {
          name: 'String'
        }
      },
      installGpuDriverEnabled: {
        required: false,
        serializedName: 'InstallGpuDriverEnabled',
        type: {
          name: 'String'
        }
      },
      username: {
        required: false,
        serializedName: 'username',
        type: {
          name: 'String'
        }
      },
      password: {
        required: false,
        serializedName: 'password',
        type: {
          name: 'String'
        }
      },
      sharedPasswordState: {
        required: false,
        serializedName: 'sharedPasswordState',
        type: {
          name: 'String'
        }
      },
      userQuota: {
        required: false,
        serializedName: 'userQuota',
        type: {
          name: 'TimeSpan'
        }
      },
      idleShutdownMode: {
        required: false,
        serializedName: 'idleShutdownMode',
        type: {
          name: 'String'
        }
      },
      idleGracePeriod: {
        required: false,
        serializedName: 'idleGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      enableDisconnectOnIdle: {
        required: false,
        serializedName: 'enableDisconnectOnIdle',
        type: {
          name: 'String'
        }
      },
      idleOsGracePeriod: {
        required: false,
        serializedName: 'idleOsGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      enableNoConnectShutdown: {
        required: false,
        serializedName: 'enableNoConnectShutdown',
        type: {
          name: 'String'
        }
      },
      idleNoConnectGracePeriod: {
        required: false,
        serializedName: 'idleNoConnectGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      connectivityPolicy: {
        required: false,
        serializedName: 'connectivityPolicy',
        type: {
          name: 'Composite',
          className: 'ConnectivityPolicy'
        }
      },
      geography: {
        required: false,
        serializedName: 'geography',
        type: {
          name: 'String'
        }
      },
      isUserListLocked: {
        required: false,
        serializedName: 'isUserListLocked',
        type: {
          name: 'Boolean'
        }
      },
      aadGroupId: {
        required: false,
        serializedName: 'aadGroupId',
        type: {
          name: 'String'
        }
      },
      lastGroupSyncTime: {
        required: false,
        serializedName: 'lastGroupSyncTime',
        type: {
          name: 'DateTime'
        }
      },
      connectedLMS: {
        required: false,
        serializedName: 'connectedLMS',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.CreateLabProperties = {
  required: false,
  serializedName: 'CreateLabProperties',
  type: {
    name: 'Composite',
    className: 'CreateLabProperties',
    modelProperties: {
      labParameters: {
        required: false,
        serializedName: 'labParameters',
        type: {
          name: 'Composite',
          className: 'LabParameters'
        }
      },
      name: {
        required: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      }
    }
  }
};
exports.EmailContent = {
  required: false,
  serializedName: 'EmailContent',
  type: {
    name: 'Composite',
    className: 'EmailContent',
    modelProperties: {
      emailAddresses: {
        required: false,
        serializedName: 'emailAddresses',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      extraMessage: {
        required: false,
        serializedName: 'extraMessage',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResourceSet = {
  required: false,
  serializedName: 'ResourceSet',
  type: {
    name: 'Composite',
    className: 'ResourceSet',
    modelProperties: {
      vmResourceId: {
        required: false,
        serializedName: 'vmResourceId',
        type: {
          name: 'String'
        }
      },
      resourceSettingId: {
        required: false,
        serializedName: 'resourceSettingId',
        type: {
          name: 'String'
        }
      },
      computeVmId: {
        required: false,
        serializedName: 'computeVmId',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.NetworkInterface = {
  required: false,
  serializedName: 'NetworkInterface',
  type: {
    name: 'Composite',
    className: 'NetworkInterface',
    modelProperties: {
      privateIpAddress: {
        required: false,
        readOnly: true,
        serializedName: 'privateIpAddress',
        type: {
          name: 'String'
        }
      },
      sshAuthority: {
        required: false,
        readOnly: true,
        serializedName: 'sshAuthority',
        type: {
          name: 'String'
        }
      },
      sshInBrowserUrl: {
        required: false,
        readOnly: true,
        serializedName: 'sshInBrowserUrl',
        type: {
          name: 'String'
        }
      },
      rdpAuthority: {
        required: false,
        readOnly: true,
        serializedName: 'rdpAuthority',
        type: {
          name: 'String'
        }
      },
      rdpInBrowserUrl: {
        required: false,
        readOnly: true,
        serializedName: 'rdpInBrowserUrl',
        type: {
          name: 'String'
        }
      },
      username: {
        required: false,
        readOnly: true,
        serializedName: 'username',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.LatestOperationResult = {
  required: false,
  serializedName: 'LatestOperationResult',
  type: {
    name: 'Composite',
    className: 'LatestOperationResult',
    modelProperties: {
      status: {
        required: false,
        readOnly: true,
        serializedName: 'status',
        type: {
          name: 'String'
        }
      },
      errorCode: {
        required: false,
        readOnly: true,
        serializedName: 'errorCode',
        type: {
          name: 'String'
        }
      },
      errorMessage: {
        required: false,
        readOnly: true,
        serializedName: 'errorMessage',
        type: {
          name: 'String'
        }
      },
      requestUri: {
        required: false,
        readOnly: true,
        serializedName: 'requestUri',
        type: {
          name: 'String'
        }
      },
      httpMethod: {
        required: false,
        readOnly: true,
        serializedName: 'httpMethod',
        type: {
          name: 'String'
        }
      },
      operationUrl: {
        required: false,
        readOnly: true,
        serializedName: 'operationUrl',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.Resource = {
  required: false,
  serializedName: 'Resource',
  type: {
    name: 'Composite',
    className: 'Resource',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      }
    }
  }
};
exports.Environment = {
  required: false,
  serializedName: 'Environment',
  type: {
    name: 'Composite',
    className: 'Environment',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      resourceSets: {
        required: false,
        serializedName: 'properties.resourceSets',
        type: {
          name: 'Composite',
          className: 'ResourceSet'
        }
      },
      claimedByUserObjectId: {
        required: false,
        readOnly: true,
        serializedName: 'properties.claimedByUserObjectId',
        type: {
          name: 'String'
        }
      },
      claimedByUserPrincipalId: {
        required: false,
        readOnly: true,
        serializedName: 'properties.claimedByUserPrincipalId',
        type: {
          name: 'String'
        }
      },
      claimedByUserName: {
        required: false,
        readOnly: true,
        serializedName: 'properties.claimedByUserName',
        type: {
          name: 'String'
        }
      },
      isClaimed: {
        required: false,
        readOnly: true,
        serializedName: 'properties.isClaimed',
        type: {
          name: 'Boolean'
        }
      },
      lastKnownPowerState: {
        required: false,
        readOnly: true,
        serializedName: 'properties.lastKnownPowerState',
        type: {
          name: 'String'
        }
      },
      networkInterface: {
        required: false,
        readOnly: true,
        serializedName: 'properties.networkInterface',
        type: {
          name: 'Composite',
          className: 'NetworkInterface'
        }
      },
      totalUsage: {
        required: false,
        readOnly: true,
        serializedName: 'properties.totalUsage',
        type: {
          name: 'TimeSpan'
        }
      },
      passwordLastReset: {
        required: false,
        readOnly: true,
        serializedName: 'properties.passwordLastReset',
        type: {
          name: 'DateTime'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      },
      latestOperationResult: {
        required: false,
        readOnly: true,
        serializedName: 'properties.latestOperationResult',
        type: {
          name: 'Composite',
          className: 'LatestOperationResult'
        }
      }
    }
  }
};
exports.EnvironmentOperationsPayload = {
  required: false,
  serializedName: 'EnvironmentOperationsPayload',
  type: {
    name: 'Composite',
    className: 'EnvironmentOperationsPayload',
    modelProperties: {
      environmentId: {
        required: true,
        serializedName: 'environmentId',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.VmStateDetails = {
  required: false,
  serializedName: 'VmStateDetails',
  type: {
    name: 'Composite',
    className: 'VmStateDetails',
    modelProperties: {
      rdpAuthority: {
        required: false,
        readOnly: true,
        serializedName: 'rdpAuthority',
        type: {
          name: 'String'
        }
      },
      rdpInBrowserUrl: {
        required: false,
        readOnly: true,
        serializedName: 'rdpInBrowserUrl',
        type: {
          name: 'String'
        }
      },
      sshAuthority: {
        required: false,
        readOnly: true,
        serializedName: 'sshAuthority',
        type: {
          name: 'String'
        }
      },
      sshInBrowserUrl: {
        required: false,
        readOnly: true,
        serializedName: 'sshInBrowserUrl',
        type: {
          name: 'String'
        }
      },
      powerState: {
        required: false,
        readOnly: true,
        serializedName: 'powerState',
        type: {
          name: 'String'
        }
      },
      lastKnownPowerState: {
        required: false,
        readOnly: true,
        serializedName: 'lastKnownPowerState',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ReferenceVm = {
  required: false,
  serializedName: 'ReferenceVm',
  type: {
    name: 'Composite',
    className: 'ReferenceVm',
    modelProperties: {
      userName: {
        required: true,
        serializedName: 'userName',
        type: {
          name: 'String'
        }
      },
      password: {
        required: false,
        serializedName: 'password',
        type: {
          name: 'String'
        }
      },
      vmStateDetails: {
        required: false,
        readOnly: true,
        serializedName: 'vmStateDetails',
        type: {
          name: 'Composite',
          className: 'VmStateDetails'
        }
      },
      vmResourceId: {
        required: false,
        readOnly: true,
        serializedName: 'vmResourceId',
        type: {
          name: 'String'
        }
      },
      computeVmId: {
        required: false,
        readOnly: true,
        serializedName: 'computeVmId',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResourceSettings = {
  required: false,
  serializedName: 'ResourceSettings',
  type: {
    name: 'Composite',
    className: 'ResourceSettings',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      galleryImageResourceId: {
        required: false,
        serializedName: 'galleryImageResourceId',
        type: {
          name: 'String'
        }
      },
      sharedImageResourceId: {
        required: false,
        serializedName: 'sharedImageResourceId',
        type: {
          name: 'String'
        }
      },
      sharedImageResourceIdForUpload: {
        required: false,
        readOnly: true,
        serializedName: 'sharedImageResourceIdForUpload',
        type: {
          name: 'String'
        }
      },
      imageName: {
        required: false,
        readOnly: true,
        serializedName: 'imageName',
        type: {
          name: 'String'
        }
      },
      vmSize: {
        required: false,
        serializedName: 'vmSize',
        type: {
          name: 'String'
        }
      },
      osType: {
        required: false,
        readOnly: true,
        serializedName: 'osType',
        type: {
          name: 'String'
        }
      },
      cores: {
        required: false,
        readOnly: true,
        serializedName: 'cores',
        type: {
          name: 'Number'
        }
      },
      referenceVm: {
        required: true,
        serializedName: 'referenceVm',
        type: {
          name: 'Composite',
          className: 'ReferenceVm'
        }
      },
      linuxRdpEnabled: {
        required: false,
        serializedName: 'LinuxRdpEnabled',
        type: {
          name: 'String'
        }
      },
      installGpuDriverEnabled: {
        required: false,
        serializedName: 'InstallGpuDriverEnabled',
        type: {
          name: 'String'
        }
      },
      gpuDriverState: {
        required: false,
        serializedName: 'GpuDriverState',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.EnvironmentSetting = {
  required: false,
  serializedName: 'EnvironmentSetting',
  type: {
    name: 'Composite',
    className: 'EnvironmentSetting',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      publishingState: {
        required: false,
        readOnly: true,
        serializedName: 'properties.publishingState',
        type: {
          name: 'String'
        }
      },
      uploadState: {
        required: false,
        readOnly: true,
        serializedName: 'properties.uploadState',
        type: {
          name: 'String'
        }
      },
      lastUploaded: {
        required: false,
        readOnly: true,
        serializedName: 'properties.lastUploaded',
        type: {
          name: 'DateTime'
        }
      },
      configurationState: {
        required: false,
        serializedName: 'properties.configurationState',
        type: {
          name: 'String'
        }
      },
      description: {
        required: false,
        serializedName: 'properties.description',
        type: {
          name: 'String'
        }
      },
      title: {
        required: false,
        serializedName: 'properties.title',
        type: {
          name: 'String'
        }
      },
      resourceSettings: {
        required: true,
        serializedName: 'properties.resourceSettings',
        type: {
          name: 'Composite',
          className: 'ResourceSettings'
        }
      },
      lastChanged: {
        required: false,
        readOnly: true,
        serializedName: 'properties.lastChanged',
        type: {
          name: 'DateTime'
        }
      },
      lastPublished: {
        required: false,
        readOnly: true,
        serializedName: 'properties.lastPublished',
        type: {
          name: 'DateTime'
        }
      },
      createdDate: {
        required: false,
        readOnly: true,
        serializedName: 'properties.createdDate',
        type: {
          name: 'DateTime'
        }
      },
      passwordLastReset: {
        required: false,
        readOnly: true,
        serializedName: 'properties.passwordLastReset',
        type: {
          name: 'DateTime'
        }
      },
      hasTemplateVm: {
        required: false,
        serializedName: 'properties.hasTemplateVm',
        type: {
          name: 'Boolean'
        }
      },
      geography: {
        required: true,
        serializedName: 'properties.geography',
        type: {
          name: 'String'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      },
      latestOperationResult: {
        required: false,
        readOnly: true,
        serializedName: 'properties.latestOperationResult',
        type: {
          name: 'Composite',
          className: 'LatestOperationResult'
        }
      }
    }
  }
};
exports.GalleryImageReference = {
  required: false,
  serializedName: 'GalleryImageReference',
  type: {
    name: 'Composite',
    className: 'GalleryImageReference',
    modelProperties: {
      offer: {
        required: false,
        serializedName: 'offer',
        type: {
          name: 'String'
        }
      },
      publisher: {
        required: false,
        serializedName: 'publisher',
        type: {
          name: 'String'
        }
      },
      sku: {
        required: false,
        serializedName: 'sku',
        type: {
          name: 'String'
        }
      },
      osType: {
        required: false,
        serializedName: 'osType',
        type: {
          name: 'String'
        }
      },
      version: {
        required: false,
        serializedName: 'version',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.GalleryImage = {
  required: false,
  serializedName: 'GalleryImage',
  type: {
    name: 'Composite',
    className: 'GalleryImage',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      author: {
        required: false,
        readOnly: true,
        serializedName: 'properties.author',
        type: {
          name: 'String'
        }
      },
      createdDate: {
        required: false,
        readOnly: true,
        serializedName: 'properties.createdDate',
        type: {
          name: 'DateTime'
        }
      },
      description: {
        required: false,
        readOnly: true,
        serializedName: 'properties.description',
        type: {
          name: 'String'
        }
      },
      imageReference: {
        required: false,
        readOnly: true,
        serializedName: 'properties.imageReference',
        type: {
          name: 'Composite',
          className: 'GalleryImageReference'
        }
      },
      icon: {
        required: false,
        readOnly: true,
        serializedName: 'properties.icon',
        type: {
          name: 'String'
        }
      },
      isEnabled: {
        required: false,
        serializedName: 'properties.isEnabled',
        type: {
          name: 'Boolean'
        }
      },
      isOverride: {
        required: false,
        serializedName: 'properties.isOverride',
        type: {
          name: 'Boolean'
        }
      },
      planId: {
        required: false,
        readOnly: true,
        serializedName: 'properties.planId',
        type: {
          name: 'String'
        }
      },
      isPlanAuthorized: {
        required: false,
        serializedName: 'properties.isPlanAuthorized',
        type: {
          name: 'Boolean'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      },
      latestOperationResult: {
        required: false,
        readOnly: true,
        serializedName: 'properties.latestOperationResult',
        type: {
          name: 'Composite',
          className: 'LatestOperationResult'
        }
      }
    }
  }
};
exports.GalleryImageFragment = {
  required: false,
  serializedName: 'GalleryImageFragment',
  type: {
    name: 'Composite',
    className: 'GalleryImageFragment',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      isEnabled: {
        required: false,
        serializedName: 'properties.isEnabled',
        type: {
          name: 'Boolean'
        }
      },
      isOverride: {
        required: false,
        serializedName: 'properties.isOverride',
        type: {
          name: 'Boolean'
        }
      },
      isPlanAuthorized: {
        required: false,
        serializedName: 'properties.isPlanAuthorized',
        type: {
          name: 'Boolean'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.GalleryImageReferenceFragment = {
  required: false,
  serializedName: 'GalleryImageReferenceFragment',
  type: {
    name: 'Composite',
    className: 'GalleryImageReferenceFragment',
    modelProperties: {
      offer: {
        required: false,
        serializedName: 'offer',
        type: {
          name: 'String'
        }
      },
      publisher: {
        required: false,
        serializedName: 'publisher',
        type: {
          name: 'String'
        }
      },
      sku: {
        required: false,
        serializedName: 'sku',
        type: {
          name: 'String'
        }
      },
      osType: {
        required: false,
        serializedName: 'osType',
        type: {
          name: 'String'
        }
      },
      version: {
        required: false,
        serializedName: 'version',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.GeographyDetails = {
  required: false,
  serializedName: 'GeographyDetails',
  type: {
    name: 'Composite',
    className: 'GeographyDetails',
    modelProperties: {
      name: {
        required: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      localizedDisplayName: {
        required: true,
        serializedName: 'localizedDisplayName',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.GeoPricingAndAvailability = {
  required: false,
  serializedName: 'GeoPricingAndAvailability',
  type: {
    name: 'Composite',
    className: 'GeoPricingAndAvailability',
    modelProperties: {
      geographyName: {
        required: true,
        serializedName: 'geographyName',
        type: {
          name: 'String'
        }
      },
      availability: {
        required: true,
        serializedName: 'availability',
        type: {
          name: 'String'
        }
      },
      localizedDisplayName: {
        required: true,
        serializedName: 'localizedDisplayName',
        type: {
          name: 'String'
        }
      },
      price: {
        required: true,
        serializedName: 'price',
        type: {
          name: 'Number'
        }
      },
      currencyCode: {
        required: true,
        serializedName: 'currencyCode',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.SizeDetails = {
  required: false,
  serializedName: 'SizeDetails',
  type: {
    name: 'Composite',
    className: 'SizeDetails',
    modelProperties: {
      sizeName: {
        required: true,
        serializedName: 'sizeName',
        type: {
          name: 'String'
        }
      },
      localizedDisplayName: {
        required: true,
        serializedName: 'localizedDisplayName',
        type: {
          name: 'String'
        }
      },
      localizedDescription: {
        required: true,
        serializedName: 'localizedDescription',
        type: {
          name: 'String'
        }
      },
      memoryInGb: {
        required: true,
        serializedName: 'memoryInGb',
        type: {
          name: 'Number'
        }
      },
      coresCount: {
        required: true,
        serializedName: 'coresCount',
        type: {
          name: 'Number'
        }
      },
      gpu: {
        required: true,
        serializedName: 'gpu',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.GetLabPricingAndAvailabilityResponse = {
  required: false,
  serializedName: 'GetLabPricingAndAvailabilityResponse',
  type: {
    name: 'Composite',
    className: 'GetLabPricingAndAvailabilityResponse',
    modelProperties: {
      availability: {
        required: true,
        serializedName: 'availability',
        type: {
          name: 'String'
        }
      },
      price: {
        required: true,
        serializedName: 'price',
        type: {
          name: 'Number'
        }
      },
      currencyCode: {
        required: true,
        serializedName: 'currencyCode',
        type: {
          name: 'String'
        }
      },
      operatingSystemName: {
        required: true,
        serializedName: 'operatingSystemName',
        type: {
          name: 'String'
        }
      },
      geography: {
        required: true,
        serializedName: 'geography',
        type: {
          name: 'Composite',
          className: 'GeographyDetails'
        }
      },
      size: {
        required: true,
        serializedName: 'size',
        type: {
          name: 'Composite',
          className: 'SizeDetails'
        }
      }
    }
  }
};
exports.SizePricingAndAvailability = {
  required: false,
  serializedName: 'SizePricingAndAvailability',
  type: {
    name: 'Composite',
    className: 'SizePricingAndAvailability',
    modelProperties: {
      sizeName: {
        required: true,
        serializedName: 'sizeName',
        type: {
          name: 'String'
        }
      },
      availability: {
        required: true,
        serializedName: 'availability',
        type: {
          name: 'String'
        }
      },
      localizedDisplayName: {
        required: true,
        serializedName: 'localizedDisplayName',
        type: {
          name: 'String'
        }
      },
      localizedDescription: {
        required: true,
        serializedName: 'localizedDescription',
        type: {
          name: 'String'
        }
      },
      ordinal: {
        required: true,
        serializedName: 'ordinal',
        type: {
          name: 'Number'
        }
      },
      memoryInGb: {
        required: true,
        serializedName: 'memoryInGb',
        type: {
          name: 'Number'
        }
      },
      coresCount: {
        required: true,
        serializedName: 'coresCount',
        type: {
          name: 'Number'
        }
      },
      gpu: {
        required: true,
        serializedName: 'gpu',
        type: {
          name: 'String'
        }
      },
      geographies: {
        required: true,
        serializedName: 'geographies',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'GeoPricingAndAvailabilityElementType',
            type: {
              name: 'Composite',
              className: 'GeoPricingAndAvailability'
            }
          }
        }
      }
    }
  }
};
exports.OSPricingAndAvailability = {
  required: false,
  serializedName: 'OSPricingAndAvailability',
  type: {
    name: 'Composite',
    className: 'OSPricingAndAvailability',
    modelProperties: {
      osName: {
        required: true,
        serializedName: 'osName',
        type: {
          name: 'String'
        }
      },
      availability: {
        required: true,
        serializedName: 'availability',
        type: {
          name: 'String'
        }
      },
      sizes: {
        required: true,
        serializedName: 'sizes',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'SizePricingAndAvailabilityElementType',
            type: {
              name: 'Composite',
              className: 'SizePricingAndAvailability'
            }
          }
        }
      }
    }
  }
};
exports.GetPricingAndAvailabilityResponse = {
  required: false,
  serializedName: 'GetPricingAndAvailabilityResponse',
  type: {
    name: 'Composite',
    className: 'GetPricingAndAvailabilityResponse',
    modelProperties: {
      operatingSystems: {
        required: true,
        serializedName: 'operatingSystems',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'OSPricingAndAvailabilityElementType',
            type: {
              name: 'Composite',
              className: 'OSPricingAndAvailability'
            }
          }
        }
      }
    }
  }
};
exports.GetRestrictionsAndUsageResponse = {
  required: false,
  serializedName: 'GetRestrictionsAndUsageResponse',
  type: {
    name: 'Composite',
    className: 'GetRestrictionsAndUsageResponse',
    modelProperties: {
      isExempt: {
        required: false,
        readOnly: true,
        serializedName: 'isExempt',
        type: {
          name: 'Boolean'
        }
      },
      usages: {
        required: false,
        readOnly: true,
        serializedName: 'usages',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'CoreDataElementType',
            type: {
              name: 'Composite',
              className: 'CoreData'
            }
          }
        }
      },
      restrictions: {
        required: false,
        readOnly: true,
        serializedName: 'restrictions',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'CoreDataElementType',
            type: {
              name: 'Composite',
              className: 'CoreData'
            }
          }
        }
      }
    }
  }
};
exports.Lab = {
  required: false,
  serializedName: 'Lab',
  type: {
    name: 'Composite',
    className: 'Lab',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      maxUsersInLab: {
        required: false,
        serializedName: 'properties.maxUsersInLab',
        type: {
          name: 'Number'
        }
      },
      userQuota: {
        required: false,
        readOnly: true,
        serializedName: 'properties.userQuota',
        type: {
          name: 'Number'
        }
      },
      invitationCode: {
        required: false,
        readOnly: true,
        serializedName: 'properties.invitationCode',
        type: {
          name: 'String'
        }
      },
      groupInvitationCode: {
        required: false,
        readOnly: true,
        serializedName: 'properties.groupInvitationCode',
        type: {
          name: 'String'
        }
      },
      createdByObjectId: {
        required: false,
        readOnly: true,
        serializedName: 'properties.createdByObjectId',
        type: {
          name: 'String'
        }
      },
      usageQuota: {
        required: true,
        serializedName: 'properties.usageQuota',
        type: {
          name: 'TimeSpan'
        }
      },
      userAccessMode: {
        required: false,
        serializedName: 'properties.userAccessMode',
        type: {
          name: 'String'
        }
      },
      createdByUserPrincipalName: {
        required: false,
        readOnly: true,
        serializedName: 'properties.createdByUserPrincipalName',
        type: {
          name: 'String'
        }
      },
      createdDate: {
        required: false,
        readOnly: true,
        serializedName: 'properties.createdDate',
        type: {
          name: 'DateTime'
        }
      },
      sharedPasswordEnabled: {
        required: false,
        serializedName: 'properties.sharedPasswordEnabled',
        type: {
          name: 'String'
        }
      },
      idleShutdownMode: {
        required: false,
        serializedName: 'properties.idleShutdownMode',
        type: {
          name: 'String'
        }
      },
      idleGracePeriod: {
        required: false,
        serializedName: 'properties.idleGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      enableDisconnectOnIdle: {
        required: false,
        serializedName: 'properties.enableDisconnectOnIdle',
        type: {
          name: 'String'
        }
      },
      idleOsGracePeriod: {
        required: false,
        serializedName: 'properties.idleOsGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      enableNoConnectShutdown: {
        required: false,
        serializedName: 'properties.enableNoConnectShutdown',
        type: {
          name: 'String'
        }
      },
      idleNoConnectGracePeriod: {
        required: false,
        serializedName: 'properties.idleNoConnectGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      connectivityPolicy: {
        required: false,
        serializedName: 'properties.connectivityPolicy',
        type: {
          name: 'Composite',
          className: 'ConnectivityPolicy'
        }
      },
      ipAddress: {
        required: false,
        readOnly: true,
        serializedName: 'properties.ipAddress',
        type: {
          name: 'String'
        }
      },
      gpuDriverStateDismissed: {
        required: false,
        serializedName: 'properties.gpuDriverStateDismissed',
        type: {
          name: 'String'
        }
      },
      idleConfigState: {
        required: false,
        readOnly: true,
        serializedName: 'properties.idleConfigState',
        type: {
          name: 'String'
        }
      },
      virtualNetworkResourceId: {
        required: false,
        readOnly: true,
        serializedName: 'properties.virtualNetworkResourceId',
        type: {
          name: 'String'
        }
      },
      isUserListLocked: {
        required: false,
        readOnly: true,
        serializedName: 'properties.isUserListLocked',
        type: {
          name: 'Boolean'
        }
      },
      aadGroupId: {
        required: false,
        serializedName: 'properties.aadGroupId',
        type: {
          name: 'String'
        }
      },
      lastGroupSyncTime: {
        required: false,
        serializedName: 'properties.lastGroupSyncTime',
        type: {
          name: 'DateTime'
        }
      },
      isDeletionExternallyManaged: {
        required: false,
        serializedName: 'properties.isDeletionExternallyManaged',
        type: {
          name: 'Boolean'
        }
      },
      connectedLMS: {
        required: false,
        serializedName: 'properties.connectedLMS',
        type: {
          name: 'String'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      },
      latestOperationResult: {
        required: false,
        readOnly: true,
        serializedName: 'properties.latestOperationResult',
        type: {
          name: 'Composite',
          className: 'LatestOperationResult'
        }
      }
    }
  }
};
exports.SupportInfo = {
  required: false,
  serializedName: 'SupportInfo',
  type: {
    name: 'Composite',
    className: 'SupportInfo',
    modelProperties: {
      url: {
        required: false,
        serializedName: 'url',
        type: {
          name: 'String'
        }
      },
      email: {
        required: false,
        serializedName: 'email',
        type: {
          name: 'String'
        }
      },
      phone: {
        required: false,
        serializedName: 'phone',
        type: {
          name: 'String'
        }
      },
      instructions: {
        required: false,
        serializedName: 'instructions',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.LabAccount = {
  required: false,
  serializedName: 'LabAccount',
  type: {
    name: 'Composite',
    className: 'LabAccount',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      enabledRegionSelection: {
        required: false,
        serializedName: 'properties.enabledRegionSelection',
        type: {
          name: 'Boolean'
        }
      },
      virtualNetworkResourceId: {
        required: false,
        serializedName: 'properties.virtualNetworkResourceId',
        type: {
          name: 'String'
        }
      },
      virtualNetworkAddressRange: {
        required: false,
        serializedName: 'properties.virtualNetworkAddressRange',
        type: {
          name: 'String'
        }
      },
      geo: {
        required: false,
        readOnly: true,
        serializedName: 'properties.geo',
        type: {
          name: 'String'
        }
      },
      labServicesObjectId: {
        required: false,
        readOnly: true,
        serializedName: 'properties.labServicesObjectId',
        type: {
          name: 'String'
        }
      },
      existingSharedImageGalleryId: {
        required: false,
        serializedName: 'properties.existingSharedImageGalleryId',
        type: {
          name: 'String'
        }
      },
      idleShutdownMode: {
        required: false,
        serializedName: 'properties.idleShutdownMode',
        type: {
          name: 'String'
        }
      },
      idleGracePeriod: {
        required: false,
        serializedName: 'properties.idleGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      enableDisconnectOnIdle: {
        required: false,
        serializedName: 'properties.enableDisconnectOnIdle',
        type: {
          name: 'String'
        }
      },
      idleOsGracePeriod: {
        required: false,
        serializedName: 'properties.idleOsGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      enableNoConnectShutdown: {
        required: false,
        serializedName: 'properties.enableNoConnectShutdown',
        type: {
          name: 'String'
        }
      },
      idleNoConnectGracePeriod: {
        required: false,
        serializedName: 'properties.idleNoConnectGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      clientConnections: {
        required: false,
        serializedName: 'properties.clientConnections',
        type: {
          name: 'String'
        }
      },
      enableBastion: {
        required: false,
        serializedName: 'properties.enableBastion',
        type: {
          name: 'String'
        }
      },
      supportInfo: {
        required: false,
        serializedName: 'properties.supportInfo',
        type: {
          name: 'Composite',
          className: 'SupportInfo'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      },
      latestOperationResult: {
        required: false,
        readOnly: true,
        serializedName: 'properties.latestOperationResult',
        type: {
          name: 'Composite',
          className: 'LatestOperationResult'
        }
      }
    }
  }
};
exports.SupportInfoFragment = {
  required: false,
  serializedName: 'SupportInfoFragment',
  type: {
    name: 'Composite',
    className: 'SupportInfoFragment',
    modelProperties: {
      url: {
        required: false,
        serializedName: 'url',
        type: {
          name: 'String'
        }
      },
      email: {
        required: false,
        serializedName: 'email',
        type: {
          name: 'String'
        }
      },
      phone: {
        required: false,
        serializedName: 'phone',
        type: {
          name: 'String'
        }
      },
      instructions: {
        required: false,
        serializedName: 'instructions',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.LabAccountFragment = {
  required: false,
  serializedName: 'LabAccountFragment',
  type: {
    name: 'Composite',
    className: 'LabAccountFragment',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      enabledRegionSelection: {
        required: false,
        serializedName: 'properties.enabledRegionSelection',
        type: {
          name: 'Boolean'
        }
      },
      virtualNetworkResourceId: {
        required: false,
        serializedName: 'properties.virtualNetworkResourceId',
        type: {
          name: 'String'
        }
      },
      virtualNetworkAddressRange: {
        required: false,
        serializedName: 'properties.virtualNetworkAddressRange',
        type: {
          name: 'String'
        }
      },
      existingSharedImageGalleryId: {
        required: false,
        serializedName: 'properties.existingSharedImageGalleryId',
        type: {
          name: 'String'
        }
      },
      idleShutdownMode: {
        required: false,
        serializedName: 'properties.idleShutdownMode',
        type: {
          name: 'String'
        }
      },
      idleGracePeriod: {
        required: false,
        serializedName: 'properties.idleGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      enableDisconnectOnIdle: {
        required: false,
        serializedName: 'properties.enableDisconnectOnIdle',
        type: {
          name: 'String'
        }
      },
      idleOsGracePeriod: {
        required: false,
        serializedName: 'properties.idleOsGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      enableNoConnectShutdown: {
        required: false,
        serializedName: 'properties.enableNoConnectShutdown',
        type: {
          name: 'String'
        }
      },
      idleNoConnectGracePeriod: {
        required: false,
        serializedName: 'properties.idleNoConnectGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      clientConnections: {
        required: false,
        serializedName: 'properties.clientConnections',
        type: {
          name: 'String'
        }
      },
      enableBastion: {
        required: false,
        serializedName: 'properties.enableBastion',
        type: {
          name: 'String'
        }
      },
      supportInfo: {
        required: false,
        serializedName: 'properties.supportInfo',
        type: {
          name: 'Composite',
          className: 'SupportInfoFragment'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.LabFragment = {
  required: false,
  serializedName: 'LabFragment',
  type: {
    name: 'Composite',
    className: 'LabFragment',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      maxUsersInLab: {
        required: false,
        serializedName: 'properties.maxUsersInLab',
        type: {
          name: 'Number'
        }
      },
      usageQuota: {
        required: false,
        serializedName: 'properties.usageQuota',
        type: {
          name: 'TimeSpan'
        }
      },
      userAccessMode: {
        required: false,
        serializedName: 'properties.userAccessMode',
        type: {
          name: 'String'
        }
      },
      sharedPasswordEnabled: {
        required: false,
        serializedName: 'properties.sharedPasswordEnabled',
        type: {
          name: 'String'
        }
      },
      idleShutdownMode: {
        required: false,
        serializedName: 'properties.idleShutdownMode',
        type: {
          name: 'String'
        }
      },
      idleGracePeriod: {
        required: false,
        serializedName: 'properties.idleGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      enableDisconnectOnIdle: {
        required: false,
        serializedName: 'properties.enableDisconnectOnIdle',
        type: {
          name: 'String'
        }
      },
      idleOsGracePeriod: {
        required: false,
        serializedName: 'properties.idleOsGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      enableNoConnectShutdown: {
        required: false,
        serializedName: 'properties.enableNoConnectShutdown',
        type: {
          name: 'String'
        }
      },
      idleNoConnectGracePeriod: {
        required: false,
        serializedName: 'properties.idleNoConnectGracePeriod',
        type: {
          name: 'TimeSpan'
        }
      },
      connectivityPolicy: {
        required: false,
        serializedName: 'properties.connectivityPolicy',
        type: {
          name: 'Composite',
          className: 'ConnectivityPolicyFragment'
        }
      },
      gpuDriverStateDismissed: {
        required: false,
        serializedName: 'properties.gpuDriverStateDismissed',
        type: {
          name: 'String'
        }
      },
      aadGroupId: {
        required: false,
        serializedName: 'properties.aadGroupId',
        type: {
          name: 'String'
        }
      },
      lastGroupSyncTime: {
        required: false,
        serializedName: 'properties.lastGroupSyncTime',
        type: {
          name: 'DateTime'
        }
      },
      isDeletionExternallyManaged: {
        required: false,
        serializedName: 'properties.isDeletionExternallyManaged',
        type: {
          name: 'Boolean'
        }
      },
      connectedLMS: {
        required: false,
        serializedName: 'properties.connectedLMS',
        type: {
          name: 'String'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.VirtualMachineDetails = {
  required: false,
  serializedName: 'VirtualMachineDetails',
  type: {
    name: 'Composite',
    className: 'VirtualMachineDetails',
    modelProperties: {
      provisioningState: {
        required: false,
        readOnly: true,
        serializedName: 'provisioningState',
        type: {
          name: 'String'
        }
      },
      rdpAuthority: {
        required: false,
        readOnly: true,
        serializedName: 'rdpAuthority',
        type: {
          name: 'String'
        }
      },
      rdpInBrowserUrl: {
        required: false,
        readOnly: true,
        serializedName: 'rdpInBrowserUrl',
        type: {
          name: 'String'
        }
      },
      sshAuthority: {
        required: false,
        readOnly: true,
        serializedName: 'sshAuthority',
        type: {
          name: 'String'
        }
      },
      sshInBrowserUrl: {
        required: false,
        readOnly: true,
        serializedName: 'sshInBrowserUrl',
        type: {
          name: 'String'
        }
      },
      privateIpAddress: {
        required: false,
        readOnly: true,
        serializedName: 'privateIpAddress',
        type: {
          name: 'String'
        }
      },
      userName: {
        required: false,
        readOnly: true,
        serializedName: 'userName',
        type: {
          name: 'String'
        }
      },
      lastKnownPowerState: {
        required: false,
        readOnly: true,
        serializedName: 'lastKnownPowerState',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ListAllEnvironmentsDetails = {
  required: false,
  serializedName: 'ListAllEnvironmentsDetails',
  type: {
    name: 'Composite',
    className: 'ListAllEnvironmentsDetails',
    modelProperties: {
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      description: {
        required: false,
        readOnly: true,
        serializedName: 'description',
        type: {
          name: 'String'
        }
      },
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      provisioningState: {
        required: false,
        readOnly: true,
        serializedName: 'provisioningState',
        type: {
          name: 'String'
        }
      },
      virtualMachineDetails: {
        required: false,
        readOnly: true,
        serializedName: 'virtualMachineDetails',
        type: {
          name: 'Composite',
          className: 'VirtualMachineDetails'
        }
      },
      latestOperationResult: {
        required: false,
        readOnly: true,
        serializedName: 'latestOperationResult',
        type: {
          name: 'Composite',
          className: 'LatestOperationResult'
        }
      },
      environmentState: {
        required: false,
        readOnly: true,
        serializedName: 'environmentState',
        type: {
          name: 'String'
        }
      },
      totalUsage: {
        required: false,
        readOnly: true,
        serializedName: 'totalUsage',
        type: {
          name: 'TimeSpan'
        }
      },
      sharedPasswordEnabled: {
        required: false,
        readOnly: true,
        serializedName: 'sharedPasswordEnabled',
        type: {
          name: 'Boolean'
        }
      },
      passwordLastReset: {
        required: false,
        readOnly: true,
        serializedName: 'passwordLastReset',
        type: {
          name: 'DateTime'
        }
      },
      lastKnownPowerState: {
        required: false,
        readOnly: true,
        serializedName: 'lastKnownPowerState',
        type: {
          name: 'String'
        }
      },
      runningInSchedule: {
        required: false,
        readOnly: true,
        serializedName: 'runningInSchedule',
        type: {
          name: 'Boolean'
        }
      },
      usageQuota: {
        required: false,
        readOnly: true,
        serializedName: 'usageQuota',
        type: {
          name: 'TimeSpan'
        }
      },
      osType: {
        required: false,
        readOnly: true,
        serializedName: 'osType',
        type: {
          name: 'String'
        }
      },
      supportInfo: {
        required: false,
        readOnly: true,
        serializedName: 'supportInfo',
        type: {
          name: 'Composite',
          className: 'SupportInfo'
        }
      }
    }
  }
};
exports.ListAllEnvironmentsResponse = {
  required: false,
  serializedName: 'ListAllEnvironmentsResponse',
  type: {
    name: 'Composite',
    className: 'ListAllEnvironmentsResponse',
    modelProperties: {
      environments: {
        required: false,
        serializedName: 'environments',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'ListAllEnvironmentsDetailsElementType',
            type: {
              name: 'Composite',
              className: 'ListAllEnvironmentsDetails'
            }
          }
        }
      }
    }
  }
};
exports.OperationError = {
  required: false,
  serializedName: 'OperationError',
  type: {
    name: 'Composite',
    className: 'OperationError',
    modelProperties: {
      code: {
        required: false,
        serializedName: 'code',
        type: {
          name: 'String'
        }
      },
      message: {
        required: false,
        serializedName: 'message',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.OperationMetadataDisplay = {
  required: false,
  serializedName: 'OperationMetadataDisplay',
  type: {
    name: 'Composite',
    className: 'OperationMetadataDisplay',
    modelProperties: {
      provider: {
        required: false,
        serializedName: 'provider',
        type: {
          name: 'String'
        }
      },
      resource: {
        required: false,
        serializedName: 'resource',
        type: {
          name: 'String'
        }
      },
      operation: {
        required: false,
        serializedName: 'operation',
        type: {
          name: 'String'
        }
      },
      description: {
        required: false,
        serializedName: 'description',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.OperationMetadata = {
  required: false,
  serializedName: 'OperationMetadata',
  type: {
    name: 'Composite',
    className: 'OperationMetadata',
    modelProperties: {
      name: {
        required: false,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      display: {
        required: false,
        serializedName: 'display',
        type: {
          name: 'Composite',
          className: 'OperationMetadataDisplay'
        }
      }
    }
  }
};
exports.OperationResult = {
  required: false,
  serializedName: 'OperationResult',
  type: {
    name: 'Composite',
    className: 'OperationResult',
    modelProperties: {
      status: {
        required: false,
        serializedName: 'status',
        type: {
          name: 'String'
        }
      },
      error: {
        required: false,
        serializedName: 'error',
        type: {
          name: 'Composite',
          className: 'OperationError'
        }
      },
      statusCode: {
        required: false,
        serializedName: 'statusCode',
        type: {
          name: 'Number'
        }
      }
    }
  }
};
exports.PublishPayload = {
  required: false,
  serializedName: 'PublishPayload',
  type: {
    name: 'Composite',
    className: 'PublishPayload',
    modelProperties: {
      useExistingImage: {
        required: false,
        serializedName: 'useExistingImage',
        type: {
          name: 'Boolean'
        }
      },
      publishFromSourceImage: {
        required: false,
        serializedName: 'publishFromSourceImage',
        type: {
          name: 'Boolean'
        }
      }
    }
  }
};
exports.RecurrencePattern = {
  required: false,
  serializedName: 'RecurrencePattern',
  type: {
    name: 'Composite',
    className: 'RecurrencePattern',
    modelProperties: {
      frequency: {
        required: true,
        serializedName: 'frequency',
        type: {
          name: 'String'
        }
      },
      weekDays: {
        required: false,
        serializedName: 'weekDays',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      interval: {
        required: false,
        serializedName: 'interval',
        type: {
          name: 'Number'
        }
      },
      until: {
        required: false,
        serializedName: 'until',
        type: {
          name: 'DateTime'
        }
      }
    }
  }
};
exports.RecurrencePatternFragment = {
  required: false,
  serializedName: 'RecurrencePatternFragment',
  type: {
    name: 'Composite',
    className: 'RecurrencePatternFragment',
    modelProperties: {
      frequency: {
        required: false,
        serializedName: 'frequency',
        type: {
          name: 'String'
        }
      },
      weekDays: {
        required: false,
        serializedName: 'weekDays',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      interval: {
        required: false,
        serializedName: 'interval',
        type: {
          name: 'Number'
        }
      },
      until: {
        required: false,
        serializedName: 'until',
        type: {
          name: 'DateTime'
        }
      }
    }
  }
};
exports.RegisterPayload = {
  required: false,
  serializedName: 'RegisterPayload',
  type: {
    name: 'Composite',
    className: 'RegisterPayload',
    modelProperties: {
      registrationCode: {
        required: false,
        serializedName: 'registrationCode',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResetPasswordPayload = {
  required: false,
  serializedName: 'ResetPasswordPayload',
  type: {
    name: 'Composite',
    className: 'ResetPasswordPayload',
    modelProperties: {
      environmentId: {
        required: true,
        serializedName: 'environmentId',
        type: {
          name: 'String'
        }
      },
      username: {
        required: false,
        serializedName: 'username',
        type: {
          name: 'String'
        }
      },
      password: {
        required: false,
        serializedName: 'password',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResetTemplatePasswordPayload = {
  required: false,
  serializedName: 'ResetTemplatePasswordPayload',
  type: {
    name: 'Composite',
    className: 'ResetTemplatePasswordPayload',
    modelProperties: {
      username: {
        required: false,
        serializedName: 'username',
        type: {
          name: 'String'
        }
      },
      password: {
        required: false,
        serializedName: 'password',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ScheduleNotificationSettings = {
  required: false,
  serializedName: 'ScheduleNotificationSettings',
  type: {
    name: 'Composite',
    className: 'ScheduleNotificationSettings',
    modelProperties: {
      enableState: {
        required: false,
        serializedName: 'enableState',
        type: {
          name: 'String'
        }
      },
      sendTimeInMinutes: {
        required: true,
        serializedName: 'sendTimeInMinutes',
        type: {
          name: 'Number'
        }
      },
      webhookUrl: {
        required: false,
        serializedName: 'webhookUrl',
        type: {
          name: 'String'
        }
      },
      emailRecipients: {
        required: false,
        serializedName: 'emailRecipients',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      locale: {
        required: false,
        serializedName: 'locale',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ScheduleAction = {
  required: false,
  serializedName: 'ScheduleAction',
  type: {
    name: 'Composite',
    className: 'ScheduleAction',
    modelProperties: {
      enableState: {
        required: false,
        serializedName: 'enableState',
        type: {
          name: 'String'
        }
      },
      notificationSettings: {
        required: false,
        serializedName: 'notificationSettings',
        type: {
          name: 'Composite',
          className: 'ScheduleNotificationSettings'
        }
      },
      actionType: {
        required: true,
        serializedName: 'actionType',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.Schedule = {
  required: false,
  serializedName: 'Schedule',
  type: {
    name: 'Composite',
    className: 'Schedule',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      enableState: {
        required: false,
        serializedName: 'properties.enableState',
        type: {
          name: 'String'
        }
      },
      start: {
        required: false,
        serializedName: 'properties.start',
        type: {
          name: 'DateTime'
        }
      },
      end: {
        required: false,
        serializedName: 'properties.end',
        type: {
          name: 'DateTime'
        }
      },
      recurrencePattern: {
        required: false,
        serializedName: 'properties.recurrencePattern',
        type: {
          name: 'Composite',
          className: 'RecurrencePattern'
        }
      },
      exclusionDates: {
        required: false,
        serializedName: 'properties.exclusionDates',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'DateElementType',
            type: {
              name: 'Date'
            }
          }
        }
      },
      timeZoneId: {
        required: false,
        serializedName: 'properties.timeZoneId',
        type: {
          name: 'String'
        }
      },
      startAction: {
        required: false,
        serializedName: 'properties.startAction',
        type: {
          name: 'Composite',
          className: 'ScheduleAction'
        }
      },
      endAction: {
        required: false,
        serializedName: 'properties.endAction',
        type: {
          name: 'Composite',
          className: 'ScheduleAction'
        }
      },
      notes: {
        required: false,
        serializedName: 'properties.notes',
        type: {
          name: 'String'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      },
      latestOperationResult: {
        required: false,
        readOnly: true,
        serializedName: 'properties.latestOperationResult',
        type: {
          name: 'Composite',
          className: 'LatestOperationResult'
        }
      }
    }
  }
};
exports.SharedGallery = {
  required: false,
  serializedName: 'SharedGallery',
  type: {
    name: 'Composite',
    className: 'SharedGallery',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      defaultState: {
        required: false,
        serializedName: 'properties.defaultState',
        type: {
          name: 'String'
        }
      },
      galleryId: {
        required: false,
        serializedName: 'properties.galleryId',
        type: {
          name: 'String'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      },
      latestOperationResult: {
        required: false,
        readOnly: true,
        serializedName: 'properties.latestOperationResult',
        type: {
          name: 'Composite',
          className: 'LatestOperationResult'
        }
      }
    }
  }
};
exports.SharedImage = {
  required: false,
  serializedName: 'SharedImage',
  type: {
    name: 'Composite',
    className: 'SharedImage',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      osType: {
        required: false,
        serializedName: 'properties.osType',
        type: {
          name: 'String'
        }
      },
      imageType: {
        required: false,
        serializedName: 'properties.imageType',
        type: {
          name: 'String'
        }
      },
      displayName: {
        required: false,
        serializedName: 'properties.displayName',
        type: {
          name: 'String'
        }
      },
      enableState: {
        required: false,
        serializedName: 'properties.EnableState',
        type: {
          name: 'String'
        }
      },
      sharedGalleryId: {
        required: false,
        serializedName: 'properties.sharedGalleryId',
        type: {
          name: 'String'
        }
      },
      definitionName: {
        required: false,
        serializedName: 'properties.definitionName',
        type: {
          name: 'String'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      },
      latestOperationResult: {
        required: false,
        readOnly: true,
        serializedName: 'properties.latestOperationResult',
        type: {
          name: 'Composite',
          className: 'LatestOperationResult'
        }
      }
    }
  }
};
exports.User = {
  required: false,
  serializedName: 'User',
  type: {
    name: 'Composite',
    className: 'User',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      email: {
        required: false,
        readOnly: true,
        serializedName: 'properties.email',
        type: {
          name: 'String'
        }
      },
      familyName: {
        required: false,
        readOnly: true,
        serializedName: 'properties.familyName',
        type: {
          name: 'String'
        }
      },
      givenName: {
        required: false,
        readOnly: true,
        serializedName: 'properties.givenName',
        type: {
          name: 'String'
        }
      },
      tenantId: {
        required: false,
        readOnly: true,
        serializedName: 'properties.tenantId',
        type: {
          name: 'String'
        }
      },
      totalUsage: {
        required: false,
        readOnly: true,
        serializedName: 'properties.totalUsage',
        type: {
          name: 'TimeSpan'
        }
      },
      registrationState: {
        required: false,
        readOnly: true,
        serializedName: 'properties.registrationState',
        type: {
          name: 'String'
        }
      },
      registrationLinkEmailState: {
        required: false,
        readOnly: true,
        serializedName: 'properties.registrationLinkEmailState',
        type: {
          name: 'String'
        }
      },
      latestRegistrationLinkEmailSent: {
        required: false,
        readOnly: true,
        serializedName: 'properties.latestRegistrationLinkEmailSent',
        type: {
          name: 'DateTime'
        }
      },
      additionalUsageQuota: {
        required: false,
        serializedName: 'properties.additionalUsageQuota',
        type: {
          name: 'TimeSpan'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      },
      latestOperationResult: {
        required: false,
        readOnly: true,
        serializedName: 'properties.latestOperationResult',
        type: {
          name: 'Composite',
          className: 'LatestOperationResult'
        }
      }
    }
  }
};
exports.SaveImagePayload = {
  required: false,
  serializedName: 'SaveImagePayload',
  type: {
    name: 'Composite',
    className: 'SaveImagePayload',
    modelProperties: {
      displayName: {
        required: false,
        serializedName: 'displayName',
        type: {
          name: 'String'
        }
      },
      sharedImageResourceId: {
        required: false,
        serializedName: 'sharedImageResourceId',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ScheduleNotificationSettingsFragment = {
  required: false,
  serializedName: 'ScheduleNotificationSettingsFragment',
  type: {
    name: 'Composite',
    className: 'ScheduleNotificationSettingsFragment',
    modelProperties: {
      enableState: {
        required: false,
        serializedName: 'enableState',
        type: {
          name: 'String'
        }
      },
      sendTimeInMinutes: {
        required: false,
        serializedName: 'sendTimeInMinutes',
        type: {
          name: 'Number'
        }
      },
      webhookUrl: {
        required: false,
        serializedName: 'webhookUrl',
        type: {
          name: 'String'
        }
      },
      emailRecipients: {
        required: false,
        serializedName: 'emailRecipients',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      locale: {
        required: false,
        serializedName: 'locale',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ScheduleActionFragment = {
  required: false,
  serializedName: 'ScheduleActionFragment',
  type: {
    name: 'Composite',
    className: 'ScheduleActionFragment',
    modelProperties: {
      enableState: {
        required: false,
        serializedName: 'enableState',
        type: {
          name: 'String'
        }
      },
      notificationSettings: {
        required: false,
        serializedName: 'notificationSettings',
        type: {
          name: 'Composite',
          className: 'ScheduleNotificationSettingsFragment'
        }
      },
      actionType: {
        required: false,
        serializedName: 'actionType',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ScheduleFragment = {
  required: false,
  serializedName: 'ScheduleFragment',
  type: {
    name: 'Composite',
    className: 'ScheduleFragment',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      enableState: {
        required: false,
        serializedName: 'properties.enableState',
        type: {
          name: 'String'
        }
      },
      start: {
        required: false,
        serializedName: 'properties.start',
        type: {
          name: 'DateTime'
        }
      },
      end: {
        required: false,
        serializedName: 'properties.end',
        type: {
          name: 'DateTime'
        }
      },
      recurrencePattern: {
        required: false,
        serializedName: 'properties.recurrencePattern',
        type: {
          name: 'Composite',
          className: 'RecurrencePatternFragment'
        }
      },
      exclusionDates: {
        required: false,
        serializedName: 'properties.exclusionDates',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'DateElementType',
            type: {
              name: 'Date'
            }
          }
        }
      },
      timeZoneId: {
        required: false,
        serializedName: 'properties.timeZoneId',
        type: {
          name: 'String'
        }
      },
      startAction: {
        required: false,
        serializedName: 'properties.startAction',
        type: {
          name: 'Composite',
          className: 'ScheduleActionFragment'
        }
      },
      endAction: {
        required: false,
        serializedName: 'properties.endAction',
        type: {
          name: 'Composite',
          className: 'ScheduleActionFragment'
        }
      },
      notes: {
        required: false,
        serializedName: 'properties.notes',
        type: {
          name: 'String'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.SharedGalleryFragment = {
  required: false,
  serializedName: 'SharedGalleryFragment',
  type: {
    name: 'Composite',
    className: 'SharedGalleryFragment',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      defaultState: {
        required: false,
        serializedName: 'properties.defaultState',
        type: {
          name: 'String'
        }
      },
      galleryId: {
        required: false,
        serializedName: 'properties.galleryId',
        type: {
          name: 'String'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.SharedImageFragment = {
  required: false,
  serializedName: 'SharedImageFragment',
  type: {
    name: 'Composite',
    className: 'SharedImageFragment',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      osType: {
        required: false,
        serializedName: 'properties.osType',
        type: {
          name: 'String'
        }
      },
      imageType: {
        required: false,
        serializedName: 'properties.imageType',
        type: {
          name: 'String'
        }
      },
      displayName: {
        required: false,
        serializedName: 'properties.displayName',
        type: {
          name: 'String'
        }
      },
      enableState: {
        required: false,
        serializedName: 'properties.EnableState',
        type: {
          name: 'String'
        }
      },
      sharedGalleryId: {
        required: false,
        serializedName: 'properties.sharedGalleryId',
        type: {
          name: 'String'
        }
      },
      definitionName: {
        required: false,
        serializedName: 'properties.definitionName',
        type: {
          name: 'String'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.UserFragment = {
  required: false,
  serializedName: 'UserFragment',
  type: {
    name: 'Composite',
    className: 'UserFragment',
    modelProperties: {
      id: {
        required: false,
        readOnly: true,
        serializedName: 'id',
        type: {
          name: 'String'
        }
      },
      name: {
        required: false,
        readOnly: true,
        serializedName: 'name',
        type: {
          name: 'String'
        }
      },
      type: {
        required: false,
        readOnly: true,
        serializedName: 'type',
        type: {
          name: 'String'
        }
      },
      location: {
        required: false,
        serializedName: 'location',
        type: {
          name: 'String'
        }
      },
      tags: {
        required: false,
        serializedName: 'tags',
        type: {
          name: 'Dictionary',
          value: {
            required: false,
            serializedName: 'stringElementType',
            type: {
              name: 'String'
            }
          }
        }
      },
      additionalUsageQuota: {
        required: false,
        serializedName: 'properties.additionalUsageQuota',
        type: {
          name: 'TimeSpan'
        }
      },
      provisioningState: {
        required: false,
        serializedName: 'properties.provisioningState',
        type: {
          name: 'String'
        }
      },
      uniqueIdentifier: {
        required: false,
        serializedName: 'properties.uniqueIdentifier',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.UserSettingsPayload = {
  required: false,
  serializedName: 'UserSettingsPayload',
  type: {
    name: 'Composite',
    className: 'UserSettingsPayload',
    modelProperties: {
      settingsJson: {
        required: false,
        serializedName: 'settingsJson',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.UserSettingsResponse = {
  required: false,
  serializedName: 'UserSettingsResponse',
  type: {
    name: 'Composite',
    className: 'UserSettingsResponse',
    modelProperties: {
      settingsJson: {
        required: false,
        serializedName: 'settingsJson',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.LabAccountsListBySubscriptionOptionalParams = {
  required: false,
  serializedName: 'ListBySubscriptionOptions',
  type: {
    name: 'Composite',
    className: 'LabAccountsListBySubscriptionOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      },
      filter: {
        required: false,
        serializedName: '$filter',
        type: {
          name: 'String'
        }
      },
      top: {
        required: false,
        serializedName: '$top',
        type: {
          name: 'Number'
        }
      },
      orderby: {
        required: false,
        serializedName: '$orderby',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.LabAccountsListByResourceGroupOptionalParams = {
  required: false,
  serializedName: 'ListByResourceGroupOptions',
  type: {
    name: 'Composite',
    className: 'LabAccountsListByResourceGroupOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      },
      filter: {
        required: false,
        serializedName: '$filter',
        type: {
          name: 'String'
        }
      },
      top: {
        required: false,
        serializedName: '$top',
        type: {
          name: 'Number'
        }
      },
      orderby: {
        required: false,
        serializedName: '$orderby',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.LabAccountsGetOptionalParams = {
  required: false,
  serializedName: 'GetOptions',
  type: {
    name: 'Composite',
    className: 'LabAccountsGetOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.LabAccountsCreateLabOptionalParams = {
  required: false,
  serializedName: 'CreateLabOptions',
  type: {
    name: 'Composite',
    className: 'LabAccountsCreateLabOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.GalleryImagesListOptionalParams = {
  required: false,
  serializedName: 'ListOptions',
  type: {
    name: 'Composite',
    className: 'GalleryImagesListOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      },
      filter: {
        required: false,
        serializedName: '$filter',
        type: {
          name: 'String'
        }
      },
      top: {
        required: false,
        serializedName: '$top',
        type: {
          name: 'Number'
        }
      },
      orderby: {
        required: false,
        serializedName: '$orderby',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.GalleryImagesGetOptionalParams = {
  required: false,
  serializedName: 'GetOptions',
  type: {
    name: 'Composite',
    className: 'GalleryImagesGetOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.LabsListOptionalParams = {
  required: false,
  serializedName: 'ListOptions',
  type: {
    name: 'Composite',
    className: 'LabsListOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      },
      filter: {
        required: false,
        serializedName: '$filter',
        type: {
          name: 'String'
        }
      },
      top: {
        required: false,
        serializedName: '$top',
        type: {
          name: 'Number'
        }
      },
      orderby: {
        required: false,
        serializedName: '$orderby',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.LabsGetOptionalParams = {
  required: false,
  serializedName: 'GetOptions',
  type: {
    name: 'Composite',
    className: 'LabsGetOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.EnvironmentSettingsListOptionalParams = {
  required: false,
  serializedName: 'ListOptions',
  type: {
    name: 'Composite',
    className: 'EnvironmentSettingsListOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      },
      filter: {
        required: false,
        serializedName: '$filter',
        type: {
          name: 'String'
        }
      },
      top: {
        required: false,
        serializedName: '$top',
        type: {
          name: 'Number'
        }
      },
      orderby: {
        required: false,
        serializedName: '$orderby',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.EnvironmentSettingsGetOptionalParams = {
  required: false,
  serializedName: 'GetOptions',
  type: {
    name: 'Composite',
    className: 'EnvironmentSettingsGetOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.EnvironmentsListOptionalParams = {
  required: false,
  serializedName: 'ListOptions',
  type: {
    name: 'Composite',
    className: 'EnvironmentsListOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      },
      filter: {
        required: false,
        serializedName: '$filter',
        type: {
          name: 'String'
        }
      },
      top: {
        required: false,
        serializedName: '$top',
        type: {
          name: 'Number'
        }
      },
      orderby: {
        required: false,
        serializedName: '$orderby',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.EnvironmentsGetOptionalParams = {
  required: false,
  serializedName: 'GetOptions',
  type: {
    name: 'Composite',
    className: 'EnvironmentsGetOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.SchedulesListOptionalParams = {
  required: false,
  serializedName: 'ListOptions',
  type: {
    name: 'Composite',
    className: 'SchedulesListOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      },
      filter: {
        required: false,
        serializedName: '$filter',
        type: {
          name: 'String'
        }
      },
      top: {
        required: false,
        serializedName: '$top',
        type: {
          name: 'Number'
        }
      },
      orderby: {
        required: false,
        serializedName: '$orderby',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.SchedulesGetOptionalParams = {
  required: false,
  serializedName: 'GetOptions',
  type: {
    name: 'Composite',
    className: 'SchedulesGetOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.UsersListOptionalParams = {
  required: false,
  serializedName: 'ListOptions',
  type: {
    name: 'Composite',
    className: 'UsersListOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      },
      filter: {
        required: false,
        serializedName: '$filter',
        type: {
          name: 'String'
        }
      },
      top: {
        required: false,
        serializedName: '$top',
        type: {
          name: 'Number'
        }
      },
      orderby: {
        required: false,
        serializedName: '$orderby',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.UsersGetOptionalParams = {
  required: false,
  serializedName: 'GetOptions',
  type: {
    name: 'Composite',
    className: 'UsersGetOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.SharedGalleriesListOptionalParams = {
  required: false,
  serializedName: 'ListOptions',
  type: {
    name: 'Composite',
    className: 'SharedGalleriesListOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      },
      filter: {
        required: false,
        serializedName: '$filter',
        type: {
          name: 'String'
        }
      },
      top: {
        required: false,
        serializedName: '$top',
        type: {
          name: 'Number'
        }
      },
      orderby: {
        required: false,
        serializedName: '$orderby',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.SharedGalleriesGetOptionalParams = {
  required: false,
  serializedName: 'GetOptions',
  type: {
    name: 'Composite',
    className: 'SharedGalleriesGetOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.SharedImagesListOptionalParams = {
  required: false,
  serializedName: 'ListOptions',
  type: {
    name: 'Composite',
    className: 'SharedImagesListOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      },
      filter: {
        required: false,
        serializedName: '$filter',
        type: {
          name: 'String'
        }
      },
      top: {
        required: false,
        serializedName: '$top',
        type: {
          name: 'Number'
        }
      },
      orderby: {
        required: false,
        serializedName: '$orderby',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.SharedImagesGetOptionalParams = {
  required: false,
  serializedName: 'GetOptions',
  type: {
    name: 'Composite',
    className: 'SharedImagesGetOptionalParams',
    modelProperties: {
      expand: {
        required: false,
        serializedName: '$expand',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ProviderOperationResult = {
  required: false,
  serializedName: 'ProviderOperationResult',
  type: {
    name: 'Composite',
    className: 'ProviderOperationResult',
    modelProperties: {
      value: {
        required: false,
        serializedName: '',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'OperationMetadataElementType',
            type: {
              name: 'Composite',
              className: 'OperationMetadata'
            }
          }
        }
      },
      nextLink: {
        required: false,
        readOnly: true,
        serializedName: 'nextLink',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResponseWithContinuationLabAccount = {
  required: false,
  serializedName: 'ResponseWithContinuation[LabAccount]',
  type: {
    name: 'Composite',
    className: 'ResponseWithContinuationLabAccount',
    modelProperties: {
      value: {
        required: false,
        serializedName: '',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'LabAccountElementType',
            type: {
              name: 'Composite',
              className: 'LabAccount'
            }
          }
        }
      },
      nextLink: {
        required: false,
        serializedName: 'nextLink',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResponseWithContinuationGalleryImage = {
  required: false,
  serializedName: 'ResponseWithContinuation[GalleryImage]',
  type: {
    name: 'Composite',
    className: 'ResponseWithContinuationGalleryImage',
    modelProperties: {
      value: {
        required: false,
        serializedName: '',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'GalleryImageElementType',
            type: {
              name: 'Composite',
              className: 'GalleryImage'
            }
          }
        }
      },
      nextLink: {
        required: false,
        serializedName: 'nextLink',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResponseWithContinuationLab = {
  required: false,
  serializedName: 'ResponseWithContinuation[Lab]',
  type: {
    name: 'Composite',
    className: 'ResponseWithContinuationLab',
    modelProperties: {
      value: {
        required: false,
        serializedName: '',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'LabElementType',
            type: {
              name: 'Composite',
              className: 'Lab'
            }
          }
        }
      },
      nextLink: {
        required: false,
        serializedName: 'nextLink',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResponseWithContinuationEnvironmentSetting = {
  required: false,
  serializedName: 'ResponseWithContinuation[EnvironmentSetting]',
  type: {
    name: 'Composite',
    className: 'ResponseWithContinuationEnvironmentSetting',
    modelProperties: {
      value: {
        required: false,
        serializedName: '',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'EnvironmentSettingElementType',
            type: {
              name: 'Composite',
              className: 'EnvironmentSetting'
            }
          }
        }
      },
      nextLink: {
        required: false,
        serializedName: 'nextLink',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResponseWithContinuationEnvironment = {
  required: false,
  serializedName: 'ResponseWithContinuation[Environment]',
  type: {
    name: 'Composite',
    className: 'ResponseWithContinuationEnvironment',
    modelProperties: {
      value: {
        required: false,
        serializedName: '',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'EnvironmentElementType',
            type: {
              name: 'Composite',
              className: 'Environment'
            }
          }
        }
      },
      nextLink: {
        required: false,
        serializedName: 'nextLink',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResponseWithContinuationSchedule = {
  required: false,
  serializedName: 'ResponseWithContinuation[Schedule]',
  type: {
    name: 'Composite',
    className: 'ResponseWithContinuationSchedule',
    modelProperties: {
      value: {
        required: false,
        serializedName: '',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'ScheduleElementType',
            type: {
              name: 'Composite',
              className: 'Schedule'
            }
          }
        }
      },
      nextLink: {
        required: false,
        serializedName: 'nextLink',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResponseWithContinuationUser = {
  required: false,
  serializedName: 'ResponseWithContinuation[User]',
  type: {
    name: 'Composite',
    className: 'ResponseWithContinuationUser',
    modelProperties: {
      value: {
        required: false,
        serializedName: '',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'UserElementType',
            type: {
              name: 'Composite',
              className: 'User'
            }
          }
        }
      },
      nextLink: {
        required: false,
        serializedName: 'nextLink',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResponseWithContinuationSharedGallery = {
  required: false,
  serializedName: 'ResponseWithContinuation[SharedGallery]',
  type: {
    name: 'Composite',
    className: 'ResponseWithContinuationSharedGallery',
    modelProperties: {
      value: {
        required: false,
        serializedName: '',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'SharedGalleryElementType',
            type: {
              name: 'Composite',
              className: 'SharedGallery'
            }
          }
        }
      },
      nextLink: {
        required: false,
        serializedName: 'nextLink',
        type: {
          name: 'String'
        }
      }
    }
  }
};
exports.ResponseWithContinuationSharedImage = {
  required: false,
  serializedName: 'ResponseWithContinuation[SharedImage]',
  type: {
    name: 'Composite',
    className: 'ResponseWithContinuationSharedImage',
    modelProperties: {
      value: {
        required: false,
        serializedName: '',
        type: {
          name: 'Sequence',
          element: {
            required: false,
            serializedName: 'SharedImageElementType',
            type: {
              name: 'Composite',
              className: 'SharedImage'
            }
          }
        }
      },
      nextLink: {
        required: false,
        serializedName: 'nextLink',
        type: {
          name: 'String'
        }
      }
    }
  }
};